import { useQuery } from "@apollo/client/react";

import { GET_USER_VERIFIED_PHONES } from "../graphql/queries/PhoneVerification";

export function useVerifiedPhoneNumbers() {
  const { data, loading, error, refetch } = useQuery(
    GET_USER_VERIFIED_PHONES,
  );

  return {
    verifiedPhoneNumbers: data?.verifiedPhoneNumbers || [],
    loading,
    error,
    refetch,
    hasVerifiedNumbers: (data?.verifiedPhoneNumbers?.length || 0) > 0,
  };
}
